// extracted by mini-css-extract-plugin
export default {"errorBoundaryComponentSmall":"Wd1DxwBNzaxfxjf2kpxd"};